// Trash Flowers case study pages. Bento (sections/tf-case-bento.liquid): uploaded reels play muted while they're on screen
// and pause off it (not at all for visitors who ask for less motion); the speaker button plays one with sound and
// mutes the others. TikTok and Instagram players only load when they come near the screen. Instagram's player needs
// at least 326px across, so it's laid out at that width (up to 540) and scaled to fill its tile.
(() => {
  const lessMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setSound = (video, on) => {
    video.muted = !on;
    const button = video.closest('.tf-bento__tile').querySelector('.tf-bento__sound');
    if (button) {
      button.setAttribute('aria-pressed', String(on));
      button.setAttribute('aria-label', on ? button.dataset.labelOff : button.dataset.labelOn);
    }
  };

  const fitInstagram = (frame) => {
    const tile = frame.parentElement;
    const base = Math.min(540, Math.max(326, tile.clientWidth));
    const scale = tile.clientWidth / base;
    frame.style.width = `${base}px`;
    frame.style.height = `${tile.clientHeight / scale}px`;
    frame.style.transform = `scale(${scale})`;
  };

  const init = (root) => {
    if (root.dataset.tfBentoReady) return;
    root.dataset.tfBentoReady = 'true';
    const videos = [...root.querySelectorAll('.tf-bento__reel video')];
    const frames = [...root.querySelectorAll('.tf-bento__frame[data-src]')];
    const instagram = [...root.querySelectorAll('.tf-bento__ig')];
    instagram.forEach(fitInstagram);
    if ('ResizeObserver' in window) {
      const resized = new ResizeObserver((entries) => entries.forEach(({ target }) => fitInstagram(target.firstElementChild)));
      instagram.forEach((frame) => resized.observe(frame.parentElement));
    }

    if ('IntersectionObserver' in window) {
      const onScreen = new IntersectionObserver(
        (entries) =>
          entries.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting) target.pause();
            else if (!lessMotion.matches || !target.muted) target.play().catch(() => {});
          }),
        { threshold: 0.5 }
      );
      videos.forEach((video) => onScreen.observe(video));

      const nearScreen = new IntersectionObserver(
        (entries) =>
          entries.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting) return;
            target.src = target.dataset.src;
            target.removeAttribute('data-src');
            nearScreen.unobserve(target);
          }),
        { rootMargin: '300px 0px' }
      );
      frames.forEach((frame) => nearScreen.observe(frame));
    } else {
      frames.forEach((frame) => {
        frame.src = frame.dataset.src;
      });
    }

    root.addEventListener('click', (event) => {
      const button = event.target.closest('.tf-bento__sound');
      if (!button) return;
      const video = button.closest('.tf-bento__tile').querySelector('video');
      const on = video.muted;
      videos.forEach((other) => setSound(other, false));
      setSound(video, on);
      if (on) video.play().catch(() => {});
    });
  };

  document.querySelectorAll('.tf-bento').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.tf-bento').forEach(init));

  // Jump buttons (sections/tf-case-intro.liquid): each scrolls to the first section of its kind further down. The hats
  // are the first product grid's section; the case study sections say what they are in data-tf-jump. A button with
  // nothing to jump to is hidden, except the shop button, which keeps its link (the collection).
  const hatsSection = () => {
    const grid = document.querySelector('.product-grid');
    return grid && (grid.closest('.shopify-section') || grid);
  };
  const jumpTarget = (key) => (key === 'hats' ? hatsSection() : document.querySelector(`[data-tf-jump~="${key}"]`));

  // Leave room for the header when it stays on screen: always on phones, and on the way up everywhere else (it shows
  // again when the page scrolls up; sections/header.liquid).
  const jumpTo = (target) => {
    const top = target.getBoundingClientRect().top + window.scrollY;
    const sticky = document.querySelector('sticky-header');
    const header = document.querySelector('.section-header');
    const headerStays = top < window.scrollY || (sticky && sticky.headerIsAlwaysSticky);
    window.scrollTo({ top: top - (header && headerStays ? header.offsetHeight : 0), behavior: lessMotion.matches ? 'auto' : 'smooth' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };

  const initJumps = (root) => {
    const nav = root.querySelector('[data-tf-jumps]');
    if (!nav || root.dataset.tfJumpsReady) return;
    root.dataset.tfJumpsReady = 'true';

    nav.querySelectorAll('[data-tf-jump-to]').forEach((link) => {
      const target = jumpTarget(link.dataset.tfJumpTo);
      if (target && !target.id) target.id = link.dataset.tfJumpTo;
      if (!target && !link.hasAttribute('data-tf-money')) link.hidden = true;
    });
    if (![...nav.children].some((link) => !link.hidden)) nav.hidden = true;

    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-tf-jump-to]');
      const target = link && jumpTarget(link.dataset.tfJumpTo);
      if (!target) return;
      event.preventDefault();
      jumpTo(target);
    });

    // Once the jump buttons scroll away, the shop button floats at the bottom of the screen until the hats or the
    // footer come into view.
    const float = root.querySelector('[data-tf-money-float]');
    if (!float || nav.hidden || !('IntersectionObserver' in window)) return;
    let passed = false;
    const stopsInView = new Set();
    const update = () => float.classList.toggle('is-shown', passed && stopsInView.size === 0);

    new IntersectionObserver(([entry]) => {
      passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(nav);

    const stops = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => (isIntersecting ? stopsInView.add(target) : stopsInView.delete(target)));
      update();
    });
    document.querySelectorAll('.product-grid').forEach((grid) => stops.observe(grid.closest('.shopify-section') || grid));
    document.querySelectorAll('.shopify-section-group-footer-group').forEach((footer) => stops.observe(footer));
  };

  document.querySelectorAll('.tf-case-intro').forEach(initJumps);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.tf-case-intro').forEach(initJumps));
})();
